export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/lyft.b27e050e.svg","height":69,"width":141,"blurWidth":0,"blurHeight":0};